import { Amplify } from "aws-amplify";
import { get, post, put } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

const authConfig = {
  Cognito: {
    userPoolId: "us-west-1_MRRH7QyfO",
    userPoolClientId: "5qt0r318huub5gh0186csj59ui",
  },
};

Amplify.configure({
  Auth: authConfig,
  API: {
    REST: {
      igniteinsights: {
        endpoint: "https://j5dk657cyb.execute-api.us-west-1.amazonaws.com/dev",
        region: "us-west-1",
      },
    },
  },
});

export async function getMatches(
  id = "",
  offset = "0",
  itemCount = "10",
  robot_number = "",
  match_event = ""
) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/matches?match_id=${id}&offset=${offset}&itemCount=${itemCount}&robot_number=${robot_number}&match_event=${match_event}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function getMatchesForTeam(robot_number = "", numMatches) {
  console.log(robot_number);
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/matches?robot_number=${robot_number}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    const parsedData = JSON.parse(json?.body);
    if (parsedData.data) {
      return parsedData.data.slice(
        parsedData.data.length - numMatches > 0
          ? parsedData.data.length - numMatches
          : 0,
        parsedData.data.length
      );
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
  }
}

export async function createMatch(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = put({
      apiName: "igniteinsights",
      path: `/matches`,
      options: {
        body: {
          body,
        },
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    return response;
  } catch (e) {
    console.log(e);
  }
}

export async function getUserMatches(username = "") {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = get({
      apiName: "igniteinsights",
      path: `/userMatches?username=${username}`,
      options: {
        headers: {
          Authorization: authToken,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function serverSideMatches(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = post({
      apiName: "igniteinsights",
      path: `/serversideMatches`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          body,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}

export async function getPreviousMatches(body) {
  const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();
  try {
    const restOperation = post({
      apiName: "igniteinsights",
      path: `/previousMatches`,
      options: {
        headers: {
          Authorization: authToken,
        },
        body: {
          body,
        },
      },
    });
    const response = await restOperation.response;
    const json = await response.body.json();
    return json;
  } catch (e) {
    console.log(e);
  }
}
